/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any */
/* tslint:disable */
// @ts-nocheck
// What's with all the above disables?
//  this is what a legacy 7 year old codebase looks like.
import { DSButton } from '@elliemae/ds-legacy-button-v1';
import { ChevronSmallDown } from '@elliemae/ds-icons';
import { styled } from '@elliemae/ds-system';

const Addon = styled(DSButton)`
  background-color: transparent;
  padding-right: 4px;
  height: 100%;
  border: none;
  font-size: 12px;
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  color: ${(props) => props.theme.colors.brand['700']};
  cursor: pointer;
  &:focus,
  &::after {
    background-color: transparent;
    box-shadow: none !important; /* needed */
    border: none !important; /* needed */
  }
`;

export const ActionAddon = ({ label, onClick, icon }) => (
  <Addon onClick={onClick} labelText={label} icon={icon || <ChevronSmallDown color={['brand-primary', 700]} />} />
);
